import { useFormik } from 'formik';
import React from 'react';
import styles from './transfer-owner.module.scss';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { Modal } from 'src/components/design-system';
import { OwnerSelector } from 'src/components/ownerSelector';
import { OWNERS_TRANSFER_OWNERSHIP } from 'shared/store/actions';
import { formatNumber } from 'shared/utils';

export function TransferOwner({ open = false, onConfirm, onDismiss, user, users, workspaceId }) {
  const [isLoading, setLoadingState] = React.useState(false);
  const [error, setError] = React.useState(null);
  const dispatch = useDispatch();

  const lang = useSelector(getLang('TRANSFER_OWNERSHIP'));

  const isBulkOperation = !!users;
  const userList = users || (user ? [user] : []);
  const excludeOwnerIds = userList.map(u => u.id);

  const onSubmit = async ({ ownerId }) => {
    setLoadingState(true);
    setError(null);

    // Call the action (either single or bulk)
    if (isBulkOperation) {
      await onConfirm({ ownerId });
    } else {
      await onConfirm({ altOwnerId: ownerId, userId: user.id });
    }

    dispatch({ type: OWNERS_TRANSFER_OWNERSHIP });

    onDismiss();

    setLoadingState(false);
  };

  // Schema
  const TRANSFER_OWNERSHIP_SCHEMA = Yup.object().shape({
    ownerId: Yup.string().required('Required'),
  });

  const { handleSubmit, setFieldValue, errors, isValid } = useFormik({
    enableReinitialize: true,
    validationSchema: TRANSFER_OWNERSHIP_SCHEMA,
    initialValues: {
      ownerId: null,
    },
    onSubmit,
  });

  const message = isBulkOperation
    ? lang.BULK_CONTENT?.replace('{count}', formatNumber(userList.length))
    : lang.CONTENT.replace('{name}', `${user?.firstName} ${user?.lastName}`);

  return (
    <Modal
      title={lang.HEADER}
      open={open}
      onSubmit={handleSubmit}
      submitText={lang.CONFIRM}
      cancelText={lang.DISMISS}
      onCancel={onDismiss}
      afterOpenChange={isOpen => {
        if (!isOpen) {
          setLoadingState(false);
          setError(null);
        }
      }}
      submitDisabled={!isValid || isLoading}
      loading={isLoading}
      submitButtonType="primary">
      <form onSubmit={handleSubmit}>
        <p className={styles.content}>{message}</p>

        <OwnerSelector
          excludeOwnerIds={excludeOwnerIds}
          error={errors.ownerId}
          placeholder={lang.DELETE_USER_POPUP_OWNER_PLACEHOLDER}
          name="ownerId"
          onChange={setFieldValue}
          workspaceId={workspaceId}
        />

        {error && <span className={styles.errorMessage}>{error}</span>}
      </form>
    </Modal>
  );
}
